<template>
  <div
    id="print-area"
    ref="printArea"
    style="display: none; display: flex; justify-content: space-between;"
  >
    <div class="nota">
      <div style="font-family: monospace; font-size: 10px; width: 100%; margin: 0; margin-bottom: 10px;">
        <div style="text-align: center;">
          <div
            style="margin: 0;"
            class="logo-wrapper"
          >
            <logo />
          </div>
          <p style="margin: 0;">
            {{ data.toko.address }}
          </p>
          <p style="margin: 0;">
            {{ data.toko.phone }}
          </p>
        </div>

        <div style="font-family: monospace; font-size: 10px; width: 100%; margin: 0; margin-top: 4px; margin-bottom: 3px;">
          <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
            <span>Nomor:</span>
            <span> &nbsp;{{ data.trx_no }}</span>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
            <span>Tanggal: </span>
            <span>&nbsp;{{ data.trx_date }}</span>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
            <span>Telp: </span>
            <span>&nbsp;{{ data.customer.raw.phone }}</span>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
            <span>Kasir: </span>
            <span>&nbsp;{{ data.salesPerson }}</span>
          </div>
          <hr style="border: none; border-top: 1px dashed #000; margin: 5px 0;">
        </div>

        <div
          v-for="item in data.items"
          :key="item.id"
          style="margin-bottom: 6px;"
        >
          <div style="margin-bottom: 2px;">
            <div style="width: 100%;">
              <b>{{ item.itemTitle.product }}</b> {{ (!item.is_stock)?`(${item.p} X ${item.l})`:'' }}
            </div>
            <div style="display: flex; flex-wrap: wrap; font-size: 10px;">
              <div style="width: 10%;">
                {{ parseInt(item.qty) }}
              </div>
              <div style="width: 90%;">
                {{ item.unit }} @ Rp{{ item.price }}
              </div>
              <div style="width: 30%;">
                disc: Rp{{ item.discount }}
              </div>
              <div style="width: 70%; text-align: right;">
                Rp{{ item.subtotal }}
              </div>
            </div>
          </div>
        </div>

        <div style="width: 100%;">
          <hr style="border: none; border-top: 1px dashed #000; margin: 5px 0;">
          Ket : {{ data.description }}
          <hr style="border: none; border-top: 1px dashed #000; margin: 5px 0;">
        </div>

        <div style="display: flex; flex-direction: column; align-items: flex-end; margin-bottom: 5px;">
          <table>
            <tr>
              <td>SubTotal</td>
              <td>: Rp{{ new Intl.NumberFormat('id-ID').format(data.total) }}</td>
            </tr>
            <tr>
              <td>Diskon</td>
              <td>: Rp{{ new Intl.NumberFormat('id-ID').format(data.disc_exp) }}</td>
            </tr>
            <tr>
              <td>Total</td>
              <td>: Rp{{ new Intl.NumberFormat('id-ID').format(data.grand_total) }}</td>
            </tr>
            <tr>
              <td>Bayar</td>
              <td>: Rp{{ new Intl.NumberFormat('id-ID').format(payment.paid_bill) }}</td>
            </tr>
            <tr>
              <td>Kembali</td>
              <td>: Rp{{ new Intl.NumberFormat('id-ID').format(payment.back_bill) }}</td>
            </tr>
            <tr>
              <td>Kurang Bayar</td>
              <td>: Rp{{ new Intl.NumberFormat('id-ID').format(data.payment_outs - payment.total_paid) }}</td>
            </tr>
          </table>
          <hr style="border: none; border-top: 1px dashed #000; margin: 5px 0;">
        </div>

        <p style="text-align: center; margin-top: 10px;">
          {{ data.toko.footer_note }}
        </p>
        <p style="text-align: center; margin: 0;">
          <vue-barcode
            v-if="data.trx_no != ''"
            :value="data.trx_no"
            format="CODE128"
            :width="2"
            :height="50"
            :font-size="10"
          />
        </p>
      </div>

    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import VueBarcode from 'vue-barcode'
import Logo from '@core/layouts/components/Logo.vue'

export default {
  components: {
    VueBarcode,
    Logo,
  },
  props: {
    activeId: {
      type: String,
      default: '',
    },
    payment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data: {
        toko: {
          address: '',
          phone: '',
          footer_note: '',
        },
        trx_no: '',
        trx_date: '',
        salesPerson: '',
        customer: {
          raw: {
            phone: '',
          },
        },
        items: [],
        description: '',
        total: 0,
        disc_exp: 0,
        grand_total: 0,
        total_paid: 0,
      },
    }
  },
  watch: {
    activeId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchPaymentData(newVal)
        }
      },
    },
    // eslint-disable-next-line func-names
    'payment.total_paid': function (newVal) {
      if (newVal !== null && newVal !== undefined) {
        this.handleTotalPaidUpdate(newVal)
      }
    },
  },
  created() {

  },
  methods: {
    formatRupiah(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      }).format(value)
    },
    print() {
      const printContents = this.$refs.printArea.innerHTML
      const w = window.open('', '', '')
      w.document.write(`
      <html>
        <head>
          <style>
            @media print {
              @page {
                size: 58mm auto;
                margin: 0;
              }
              body {
                font-family: monospace;
                font-size: 10px;
                margin: 0;
                padding: 5px;
              }
              .center { text-align: center; }
              tr {font-size: 10px; }
              hr { border: dashed 1px black; }
              .logo-wrapper img {
                max-width: 100%;
                height: auto;
                display: inline-block;
                max-width: 200px;
                margin-bottom: 40px;
                margin-top: 20px;
              }
            }
          </style>
        </head>
        <body onload="window.print();window.close(); ">
          ${printContents}
        </body>
      </html>
    `)
      w.document.close()
    },
    fetchPaymentData() {
      this.$http.get(`cashier/sales/${this.activeId}`)
        .then(res => {
          const sales = res.data

          this.data.salesPerson = sales.pic
          this.data.id = sales.id

          this.data.customer = {
            value: sales.customer.id,
            customer: sales.customer.name,
            raw: sales.customer,
          }

          this.data.trx_date = sales.trx_date
          this.data.trx_no = sales.trx_no
          this.data.description = sales.desc
          this.data.grand_total = sales.grand_total
          this.data.payment_outs = (sales.grand_total - (sales.payments_sum_nominal == null ? 0 : sales.payments_sum_nominal))
          this.data.total = sales.total
          this.data.disc_exp = sales.disc_exp
          this.data.payment_due = sales.payment_due
          this.data.prod_id = sales.prod_id

          if (sales.shipping_id) {
            this.data.shipping_id = {
              value: sales.shipping.id,
              shipping: sales.shipping.name,
            }
          }

          this.data.items = sales.details.map(item => ({
            itemTitle: {
              value: item.product.name,
              product: item.product.product,
            },
            price: new Intl.NumberFormat('id-ID').format(item.price),
            discount: new Intl.NumberFormat('id-ID').format((item.price * item.l * item.p * item.qty) - item.subtotal),
            subtotal: new Intl.NumberFormat('id-ID').format(item.subtotal),
            unit: item.product.unit.name,
            qty: item.qty,
            note: item.desc,
            p: item.p,
            l: item.l,
          })).filter(Boolean) // hilangkan yang null

          this.$http.get('/company')
            .then(comp => {
              this.data.toko = comp.data.data
            })
            .catch(error => {
              console.error('Gagal ambil data produk:', error)
            })
        })
        .catch(error => {
          console.error('Gagal ambil data sales:', error)
        })
    },
    handleTotalPaidUpdate(value) {
      this.data.total_paid = value
    },

  },
}
</script>
